import { Chip, Rating } from "@mui/material"
import moment from "moment"
import { Link } from "react-router-dom"

export default function DocumentItem({ data, linkTo }) {
    return <div className="mb-[40px]">
        <Link to={linkTo}><b className="text-2xl">{data.title}</b></Link>
        {data.publisher ? <>
            <br/>
            <i className="text-gray-400">by {data.publisher}</i>
        </> : "" }
        <br/>
        <Rating value={data.rating} readOnly size="small" />
        <br/>
        <br/>
        <Chip label={data.interest} color="primary" />
        <Chip label={data.language} color="secondary" className="ml-2"/>
        <Chip label={data.disciplinaryContext} color="success" className="ml-2"/>
        <span className="ml-3">{moment(data.uploadDate).local().format("YYYY-MM-DD")}</span>
    </div>
}